import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { Row, Col, ListGroup } from 'react-bootstrap'
import { PlayFill } from 'react-bootstrap-icons'
import { getAlbumUrl } from '../../api/api.cdlbt.co'
import { PlayerContext } from '../../pages/Home'

const RecordingItem = ({ recording, index, playFn }) => {
  const { playRecordings } = useContext(PlayerContext)

  if (!recording) return ''

  const recordingLink = `/recording/${recording.name}`
  const makeLink = `/chassis/${recording.vehicle.chassis.partMake.makeId}`
  const chassisLink = `${makeLink}/${recording.vehicle.chassis.partId}`
  const operatorLink = `/operator/${recording.vehicle.op.opId}`

  return (
    <ListGroup.Item
      role='card'
      className={'recording-item rounded border-0 mb-3'}
    >
      <Row>
        <Col
          xs={3}
          className='d-flex flex-column justify-content-center pt-2 pb-2'
        >
          <img
            className={`rounded ${recording.vehicle.chassis.partMake.makeId}`}
            src={getAlbumUrl(
              recording.vehicle.body.partMake.makeId,
              recording.vehicle.body.partId
            )}
            alt={recording.name}
          />
        </Col>
        <Col xs={7} className='d-flex flex-column justify-content-center'>
          <h6 className='mb-1 fw-semibold text-truncate'>
            <Link
              to={chassisLink}
              className='text-body link-underline link-underline-opacity-0 link-underline-opacity-75-hover'
            >
              {recording.vehicle.chassis.partMake?.makeName}{' '}
              {recording.vehicle.chassis.partName}
            </Link>
          </h6>
          <h5 className='mb-0 fw-bold'>
            <Link className='reg'>{recording.vehicle.regName}</Link>
          </h5>
          <small className='d-block text-truncate'>
            {recording.vehicle.op?.opName}
            {recording.vehicle.fleetNo ? ` - ${recording.vehicle.fleetNo}` : ''}
          </small>
        </Col>
        <Col xs={2} className='d-flex flex-column justify-content-center'>
          <button
            className='btn p-0 recording-item-play'
            onClick={() => playFn(index)}
          >
            <PlayFill className='w-100' size={36} />
          </button>
        </Col>
      </Row>
    </ListGroup.Item>
  )
}
export default RecordingItem
